import React, { useState } from 'react'
import './style.css'
import { useCountContext } from "../../utils/global";
import Form from '../form'

function Index() {
  const [state, dispatch] = useCountContext();
  const [contact, setContact] = useState(false);
  const handleClose = () => {
    dispatch({
      type: 'close'
    })
  }
  const handleContact = () => {
    dispatch({
      type: 'contact'
    })
    // if (!contact) {
    //   setContact(true)
    // } else {
    //   setContact(false)
    // }
  }

  return (
    <div>
      {!state.contact ? <div className='bio'>
        <h1>Hello! I'm Jasper </h1>
        <p className="aboutP">I recently graduated from the Coding Bootcamp at University of Sydney.</p>
        <p className="aboutP">I am currently working as an intern backend engineer at a video platform startup.</p>
        <p className="aboutP">I spend more of my waking hours trying out new things with HTML CSS and Javascript.</p>
        <p className="aboutP">I especially love the mechanical aspect of web development and the challenges that come with meshing all the logics together seamlessly.</p>
        <p className="aboutP">I have an undying passion for learning new technologies, new ways to solve problems, and, solving new problems! </p>
        <p className="aboutP">I have a dog and I like playing guitar :)</p>
        <button className='contact' onClick={handleContact} >Contact Me</button>
        <div>
          <a href='https://www.linkedin.com/in/jasper-du-761b7b195/' target='_blank' ><span className='fontA fab fa-linkedin-in'></span></a>
          <a href='https://github.com/Jasper8628' target="_blank" ><span className='fontA fab fa-github'></span></a>
          <a href='mailto:msavantfou@gmail.com' target="_blank" ><span className='fontA fas fa-envelope'></span></a>
        </div>
      </div> : <div>
          <Form />
        </div>
      }
      <button className='home' onClick={handleClose} style={{ display: state.home }} ><span className='fas fa-chevron-left'></span> Contact Me</button>
    </div>
  )
}

export default Index
